import { useQuery } from '@tanstack/react-query';
import { getAssessmentsRating } from './Autorating.services';
import { useAutoratingStore } from './Autorating.store';

export const useGetAssessmentRatingQuery = ({ org_id, submission_id, enabled }) => {
  const setFilledWithAI = useAutoratingStore((state) => state?.setFilledWithAI);
  const setResponseData = useAutoratingStore((state) => state?.setResponseData);
  const reset = useAutoratingStore((state) => state?.reset);
  return useQuery({
    queryKey: ['AI_assesment', submission_id],
    queryFn: () => getAssessmentsRating({ org_id, submission_id }),
    enabled,
    onSuccess: (response) => {
      setFilledWithAI();
      setResponseData(response);
    },
    onError: () => {
      reset();
    },
  });
};
